import { Component, EventEmitter, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'mark-all-as-done',
    templateUrl: './mark-all-as-done.component.html',
    styleUrls: ['./mark-all-as-done.component.scss'],
})
export class MarkAllAsDoneComponent {
    @Output() dontAskAgainChange = new EventEmitter<boolean>();
    constructor() {}

    onDontAskAgainChange($event: MatCheckboxChange) {
        this.dontAskAgainChange.emit($event.checked);
    }
}
